import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { EncrDecrService } from '../../services/encr-decr.service';
import { element } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-s-edit-customer',
  templateUrl: './s-edit-customer.component.html',
  styleUrls: ['./s-edit-customer.component.css']
})
export class SEditCustomerComponent implements OnInit {
  user_id: any = '';
  token: any = '';
  APIKEY: any = 'SOAV2@123';
  buttonDisabled: boolean;
  model: any = {};
  myDateValue: Date;
  factLanguage: any = {};
  arr: any[] = [];
  key_info: any = {};
  company_id: any = 0;
  edit_factoring_mode: boolean = false;
  modelexpiration_date: any = '';
  submitForm: FormGroup;
  noticeOfAssignmentDoc: any;
  factReadOnly: boolean = true;
  showpdficon: string;
  loaderMode = false;
  notice_of_assignment_doc_path_old: any;
  invoice_number: any;
  modified_by: any;
  modified_at: any;
  created_at: any;
  created_by: any;
  DynamicError: boolean;
  showdoc: string;
  imagePath: any = 'assets/images/users/profile_pic.png';
  constructor(private _company: CompanyService,
    private _factLang: FactLanguageService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,
    private formbuilder: FormBuilder,
  ) { }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }
  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.token = localStorage.getItem('token');

    this._activatedroute.params.subscribe(params => {
      this.company_id = this.EncrDecr.get(localStorage.getItem('key'), params['id']);

    });
    // this._activatedroute.params.subscribe(params => {
    //   this.company_id = params['id'];
    // });

    this.get_company_by_id();

    this.myDateValue = new Date();
    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [this.company_id],
      dynamicFields: this.formbuilder.array([]),
      advance_rate: '',
      inv_number: '',
      modified_by: '',
      modified_at: '',
      created_at: '',
      created_by: ''
    });
    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      account_id: [0],
      is_primary_account: [true, Validators.required],
      account_name: [''],
      account_number: [''],
      description: [''],
      ach: [true],
      wire: [false],

    });
    //this.dynamicFields.push(dynamicFieldForm);
  }

  public onSaveFactLang(value: boolean) {
    if (value == true) {
      this.model["edit_factoring"] = true;
    }
    else {
      this.model["edit_factoring"] = false;
    }
  }

  accOnKey(event: any) {
    this.model["email_per_invoice"] = event.target.value;
  }


  //function added by deepak on 13/07/2022
  onlynumber(evt) {
    // this.errorMsg = false;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }


  onSubmit(form) {
    this.loaderMode = true;
    // console.log(this.model["assigned_notice"]);
    this.addAccount('yy');

    this.model["company_id"] = this.company_id;
    this.model["APIKEY"] = this.APIKEY;
    //console.log(this.model);  return false; 
    var encrypted_id = this.EncrDecr.set(localStorage.getItem('key'), this.model.password);
    this.model.password = encrypted_id;
    this.invoice_number = this.model["invoice_number"];
    this.modified_by = this.model["modified_by"];
    this.modified_at = this.model["modified_at"];
    this.created_at = this.model["created_at"];
    this.created_by = this.model["created_by"];

    // return false;
    const formData = new FormData();
    formData.append('company_id', this.company_id);
    formData.append('user_id', this.user_id);
    formData.append('APIKEY', this.APIKEY);
    formData.append('password', encrypted_id);
    formData.append('acc_email', this.model["acc_email"]);
    formData.append('address1', this.model["address1"]);
    formData.append('address2', this.model["address2"]);
    formData.append('address_id', this.model["address_id"]);
    formData.append('assign_fileupload', this.model["assign_fileupload"]);
    formData.append('assign_soa', this.model["assign_soa"]);
    formData.append('assigned_notice', this.model["assigned_notice"]);
    formData.append('c_id', this.model["c_id"]);
    formData.append('cc_email', this.model["cc_email"]);
    formData.append('city', this.model["city"]);
    formData.append('company_name', this.model["company_name"]);
    formData.append('contact_name', this.model["contact_name"]);
    formData.append('country', this.model["country"]);
    formData.append('delete_status', this.model["delete_status"]);
    formData.append('due_date', this.model["due_date"]);
    formData.append('edit_factoring', this.model["edit_factoring"]);
    formData.append('email', this.model["email"]);
    formData.append('email_per_invoice', this.model["email_per_invoice"]);
    formData.append('expiration_date', this.model["expiration_date"]);
    formData.append('fact_address1', this.model["fact_address1"]);
    formData.append('fact_auth_person', this.model["fact_auth_person"]);
    formData.append('fact_city_state', this.model["fact_city_state"]);
    formData.append('fact_email', this.model["fact_email"]);
    formData.append('fact_id', this.model["fact_id"]);
    formData.append('fact_phone', this.model["fact_phone"]);
    formData.append('fact_soa_email', this.model["fact_soa_email"]);
    formData.append('finance_company', this.model["finance_company"]);
    formData.append('high_alert_email', this.model["high_alert_email"]);
    formData.append('instructions', this.model["instructions"]);
    formData.append('mobile_reminder', this.model["mobile_reminder"]);
    formData.append('notification_email', this.model["notification_email"]);
    formData.append('owner_id', this.model["owner_id"]);
    formData.append('package_id', this.model["package_id"]);
    formData.append('phone', this.model["phone"]);
    formData.append('recurring', this.model["recurring"]);
    formData.append('reminder_day_after', this.model["reminder_day_after"]);
    formData.append('reminder_day_before', this.model["reminder_day_before"]);
    formData.append('soa_assignment', this.model["soa_assignment"]);
    formData.append('stamp_location', this.model["stamp_location"]);
    formData.append('state', this.model["state"]);
    formData.append('status', this.model["status"]);
    formData.append('zip', this.model["zip"]);
    formData.append('notice_of_assignment_doc_path', this.noticeOfAssignmentDoc);
    formData.append('notice_of_assignment_doc_path_old', this.notice_of_assignment_doc_path_old);
    formData.append('company_logo_path_old', this.imagePath);
    if (this.model['company_code'] != undefined) {
      formData.append('company_code', this.model["company_code"]);
    }
    this._company.updateCmp(formData)
      .subscribe(
        res => {
          this.loaderMode = false;
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
            // if (this.DynamicError == false) {
            //   alert('dynamic false');
            this._router.navigate(['super-admin/customer-list/active']);
            // } else {
            //   alert('dynamic ekse');
            // }

          }
          else {
            this.toastr.error(res.message, 'Error');
          }

        },
      );
  }


  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }
    this._company.getCompanyById(data)
      .subscribe(
        res => {
          if (res.dataAccount.length > 0) {
            //  this.dynamicFields.removeAt(0);
            for (let item of res.dataAccount) {
              if (item.is_ach == 0) {
                item.is_ach = false;
              } else {
                item.is_ach = true;
              }
              if (item.is_wire == 0) {
                item.is_wire = false;
              } else {
                item.is_wire = true;
              }
              const dynamicFieldForm = this.formbuilder.group({
                id: [0],
                account_id: item.account_id,
                is_primary_account: (item.is_primary_account == 1) ? true : false,
                account_name: item.account_name,
                account_number: item.account_number,
                description: item.description,
                ach: item.is_ach,
                wire: item.is_wire,
              });
              this.dynamicFields.push(dynamicFieldForm);
            }
          }
          if (res.data.edit_factoring == 1) {
            this.edit_factoring_mode = true;
          }
          if (res.data.edit_factoring == 1) {
            this.edit_factoring_mode = true;
            this.factReadOnly = false;
          }
          // console.log(res.data.notice_of_assignment_doc_path);
          if (res.data.notice_of_assignment_doc_path == null || res.data.notice_of_assignment_doc_path == '') {
            this.model["notice_of_assignment_doc_path"] = '';
            this.showpdficon = 'no';
            this.notice_of_assignment_doc_path_old = '';
          } else {
            this.showpdficon = 'yes';
            this.model["notice_of_assignment_doc_path"] = res.data.notice_of_assignment_doc_path;
            this.notice_of_assignment_doc_path_old = res.data.notice_of_assignment_doc_path;
          }
          if (res.data.advance_rate != null) {
            this.submitForm.get('advance_rate').setValue(res.data.advance_rate);
          }
          this.model = res.data;
          if (res.data.company_code == null || res.data.company_code == 'null') {
            this.model["company_code"] = '';
          }
          if (this.model["acc_email"] == 'undefined') {
            this.model["acc_email"] = '';
          }
          if (this.model["cc_email"] == 'undefined') {
            this.model["cc_email"] = '';
          }
          if (this.model["notification_email"] == 'undefined') {
            this.model["notification_email"] = '';
          }

          this.imagePath = res.data.company_logo_path;
          this.model.password = this.EncrDecr.get(localStorage.getItem('key'), this.model.password);
          // console.log(this.model["assigned_notice"]);
        },
        err => console.log(err)
      );
  }



  addLine(index = 0) {
    var j = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      if (element.is_primary_account == true) {
        j++;
        // alert('j'+j);
      }
    });
    if (j == 0) {
      // alert(j+'j if');
      const dynamicFieldForm = this.formbuilder.group({
        id: [0],
        account_id: [0],
        is_primary_account: [true],
        account_name: [''],
        account_number: [''],
        description: [''],
        ach: [true],
        wire: [false],
      });
      this.dynamicFields.push(dynamicFieldForm);
    } else {
      // alert(j+'j else');
      const dynamicFieldForm = this.formbuilder.group({
        id: [0],
        account_id: [0],
        is_primary_account: [false],
        account_name: [''],
        account_number: [''],
        description: [''],
        ach: [true],
        wire: [false],
      });
      this.dynamicFields.push(dynamicFieldForm);
    }
  }


  addAccount(status = 'Act') {
    var isErrorDynamic = 0;
    // this.submitForm.value.dynamicFields.forEach(element => {
    //   if (element.account_id == 0 && (element.account_name == '' || element.account_number == '' || element.description == '')) {
    //     console.log('valid data in fields');
    //     isErrorDynamic = 0;
    //   }
    //   if (element.account_id != 0 && (element.account_name == '' || element.account_number == '' || element.description == '')) {
    //     console.log('invalid data in fields');
    //     isErrorDynamic++;
    //   }
    //   else {
    //     isErrorDynamic = isErrorDynamic + 0;
    //     console.log('all valid data in fields');
    //   }
    //   console.log(isErrorDynamic + 'iserror');
    // });
    // if (isErrorDynamic == 0) {
    //   this.DynamicError = false;
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.submitForm.get('user_id').setValue(this.user_id);
    this.submitForm.get('inv_number').setValue(this.invoice_number);
    this.submitForm.get('created_at').setValue(this.created_at);
    this.submitForm.get('created_by').setValue(this.created_by);
    this.submitForm.get('modified_at').setValue(this.modified_at);
    this.submitForm.get('modified_by').setValue(this.modified_by);
    this._company.addAccount(this.submitForm.getRawValue()).subscribe(
      (response) => {
        if (response && response['status'] == true) {
        }
      }, err => {
        console.log(err);
      });
    // }
    // else {
    //   this.DynamicError = true;
    // }
  }
  uncheckall(index) {
    var i = 0;

    this.submitForm.value.dynamicFields.forEach(element => {
      if (i != index) {
        element.is_primary_account = false;
      }
      else if (i == index) {
        element.is_primary_account = true;
      }
      else {
        console.log('else');
      } i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  deleteRow(lessonIndex) {
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {

      var sss = new Array();

      i = 0;
      var prime = 0;
      var primary = 0;
      this.submitForm.value.dynamicFields.forEach(element => {

        if (i == lessonIndex) {
          if (element.is_primary_account == true) {
            prime = 1;
          }

        }

        if (i == lessonIndex) {
          // element.is_primary_account = true;

          if (element.is_primary_account == false) {
            // alert('alert not primary');
            primary = primary + 1;
            sss.push(i);

            if (element.account_id != '') {
              const accdelete = {
                APIKEY: this.APIKEY,
                user_id: this.user_id,
                company_id: this.company_id,
                account_id: element.account_id,
              }

              this._company.deleteAccount(accdelete).subscribe(
                (response) => {

                  if (response && response['status'] == true && response['data'] != '') {
                    this.addAccount('yy');
                    this.toastr.success(response.message, 'Success');
                    // this.getFolderDocument(this.folderid, 'document');
                  }
                  else {
                    this.toastr.error(response.message, 'Error');
                  }
                });
            }
          }
          else {
            alert('You can not delete a primary account please add another primary account to delete this one.');
            primary = primary + 0;
          }
        }

        i++;
      });

      for (var i = sss.length - 1; i >= 0; i--) {
        this.dynamicFields.removeAt(sss[i]);
      }
      if (primary != 0) {
        var i = 1;
        this.submitForm.value.dynamicFields.forEach(element => {
          if (element.is_primary_account == true) {
            i = 0;
            // console.log(element.is_primary_account + i);
          }
        });
        var j = 0;
        this.submitForm.value.dynamicFields.forEach(element => {
          if (j == 0 && i == 1) {
            element.is_primary_account = true;
            // console.log(element.is_primary_account + 'delete368');
            j++;
          }
        });

        this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
      }

    }
  }


  submit_form() {
    $("#save_click").click();


  }


  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      // console.log(event.target.files[0]['type']);
      if (event.target.files[0]['type'] == 'application/pdf') {
        this.noticeOfAssignmentDoc = event.target.files[0];
      } else {
        alert('Please upload PDF file only.');
        $("#fileupload").val('');
      }
    }
    // this.noticeOfAssignmentDoc = event.target.files[0];
    // console.log(this.noticeOfAssignmentDoc.name);
    // this.showdoc='https://staffingsoav1.mybizpad.com/rest_api/';
  }

  setonecheckbox(index, val) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      if (i == index) {
        if (val == 'ach') {
          element.wire = false;
          element.ach = true;
        } if (val == 'wire') {
          element.ach = false;
          element.wire = true;
        }
      }
      i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }
  advance(value: any) {
    if (value > 100 || value < 0) {
      alert('advance rate should be greater than 0 and less than 100');
      this.submitForm.get('advance_rate').setValue('');
    }
    // else{
    // alert(value);
    //}
  }

  onlyAlpha_numberic(evt) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }

  onlyAlpha_numberic_address(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46 || ASCIICode == 35)
      return true;
    return false;
  }

}
